const MIN_QUANTITY = 0

export default function bundle({ stores }: CommandArgs) {
  const bundleStore: BundleStore = stores['bundle']

  function setTicketQuantities(item: BundleItem, quantities: Record<string, number>) {
    bundleStore.quantitiesByBundleItem.set(item.id, { ...quantities })
  }

  function setTicketQuantity(item: BundleItem, ticketId: string, quantity: number) {
    setTicketQuantities(item, { ...bundleStore.getTicketQuantities(item), [ticketId]: Math.max(MIN_QUANTITY, quantity) })
  }

  function incrementTicketQuantity(item: BundleItem, ticketId: string) {
    setTicketQuantity(item, ticketId, bundleStore.getTicketQuantity(item, ticketId) + 1)
  }

  function decrementTicketQuantity(item: BundleItem, ticketId: string) {
    setTicketQuantity(item, ticketId, bundleStore.getTicketQuantity(item, ticketId) - 1)
  }

  function retryAvailability() {
    return bundleStore.availability.retry()
  }

  function invalidateAvailability() {
    return bundleStore.availability.invalidate()
  }

  return {
    incrementTicketQuantity,
    decrementTicketQuantity,
    setTicketQuantities,
    retryAvailability,
    invalidateAvailability
  }
}

declare global {
  export type BundleCommands = ReturnType<typeof bundle>

  interface CommandRegistry {
    bundle: BundleCommands
  }
}
